module.exports = __webpack_public_path__ + "static/Raleway-LightItalic-315d3e6323b0051660d587565e3a0784.woff2";